export default __webpack_public_path__ + "static/media/euronewsLogo.e04390d9.svg";